import Loadable from "react-loadable";
import PageSpinner from "../../../components/PageSpinner";

export default Loadable({
    loader: () => import("./index"),
    loading() {
        return <PageSpinner />;
    },
});
